import React, { forwardRef } from 'react'
import classNames from 'classnames'
import useThemeClass from 'utils/hooks/useThemeClass'
import Highlighter from 'react-highlight-words'
import { Button, Tag, Tooltip } from 'components/ui'

import {
    HiCheckCircle,
    HiPlus,
    HiOutlineCog6Tooth,
    HiOutlineBuildingOffice,
    HiOutlineUsers,
} from 'react-icons/hi2'
import { useSelector } from 'react-redux'
import { find, includes } from 'lodash'
import { ORG_EDIT_SCOPE } from 'constants/scopes.constant'

const OrganizeCard = forwardRef((props, ref) => {
    const {
        id,
        active,
        disabled,
        showSettingTools,
        type,
        name,
        role,
        is_need_resubmit, // 是否需要補件
        onClick,
        onToolsClick,
        onCheckResubmit,
    } = props

    const { organizations } = useSelector((state) => state.auth.user)

    const organization = find(organizations, { id })

    const canOrgEdit = includes(organization?.scopes, ORG_EDIT_SCOPE)

    const searchWords = ['']
    const { textTheme } = useThemeClass()

    const handleToolsClick = (id) => {
        onToolsClick?.(id)
    }

    const handleCheckResubmit = (e) => {
        e.stopPropagation()
        onCheckResubmit?.()
    }

    const renderIcon = () => {
        if (!name) return <HiPlus color="black" size="14" />
        return type === 1 ? (
            <HiOutlineBuildingOffice size={24} color="black" />
        ) : (
            <HiOutlineUsers size={24} color="black" />
        )
    }

    return (
        <div
            ref={ref}
            onClick={onClick}
            className={classNames(
                'flex',
                'justify-between',
                'border',
                'rounded-md ',
                'py-4 px-3',
                'cursor-pointer',
                'select-none',
                'w-full',
                'bg-gray-50',
                active ? 'ring-cyan-500 border-cyan-500' : 'ring-transparent',
                disabled
                    ? 'opacity-50 cursor-not-allowed'
                    : 'hover:ring-cyan-500 hover:border-cyan-500'
            )}
        >
            <div className="flex items-center">
                <div
                    className={classNames(
                        'mr-4 rounded-md ring-1 ring-slate-900/5 shadow-sm text-xl group-hover:shadow h-6 w-6 flex items-center justify-center bg-white dark:bg-gray-700',
                        textTheme,
                        'dark:text-gray-100'
                    )}
                >
                    {renderIcon()}
                </div>
                <div className="text-gray-900 dark:text-gray-300">
                    <h6 className="text-sm">
                        {name ? (
                            <Highlighter
                                autoEscape
                                highlightClassName={classNames(
                                    textTheme,
                                    'underline bg-transparent font-semibold dark:text-white'
                                )}
                                searchWords={searchWords}
                                textToHighlight={name}
                            />
                        ) : (
                            '選擇組織'
                        )}
                    </h6>
                    <p className="text-xs text-gray-600">
                        {role}
                        {/* {type === 1 ? vat_number : owner_phone} */}
                    </p>
                </div>
            </div>
            <div className="flex items-center gap-2">
                {showSettingTools && is_need_resubmit && (
                    <div onClick={handleCheckResubmit}>
                        {canOrgEdit ? (
                            <Tag
                                className={classNames(
                                    'text-red-600 bg-red-100 dark:text-red-100 dark:bg-red-500/20 border-0'
                                )}
                            >
                                補件通知
                            </Tag>
                        ) : (
                            <Tooltip title="沒有權限">
                                <Tag
                                    className={classNames(
                                        'text-red-600 bg-red-100 dark:text-red-100 dark:bg-red-500/20 border-0',
                                        'opacity-50 cursor-not-allowed'
                                    )}
                                >
                                    補件通知
                                </Tag>
                            </Tooltip>
                        )}
                    </div>
                )}

                {active && <HiCheckCircle className="text-cyan-500 text-xl" />}

                {showSettingTools && (
                    <Button
                        size="xs"
                        variant="plain"
                        icon={<HiOutlineCog6Tooth size={24} />}
                        onClick={(e) => {
                            e.stopPropagation()
                            handleToolsClick(id)
                        }}
                    />
                )}
            </div>
        </div>
    )
})

export default OrganizeCard
